import { useMutation } from 'react-query';

import {
  createDutyLine,
  createDutyLineWithoutRequest
} from 'RestAPIs/duty-lines';

type SaveDutyLineOptions = {
  deleteAbsences?: boolean;
  duty: Record<string, unknown>;
  isWithoutRequest: boolean;
};

export const useSaveDutyLineForAbsenceMutation = () => {
  return useMutation(
    ({ duty, deleteAbsences, isWithoutRequest }: SaveDutyLineOptions) => {
      if (isWithoutRequest) {
        return createDutyLineWithoutRequest({
          duty,
          deleteAbsences,
          ignoreAbsenceOverlap: true
        });
      } else {
        return createDutyLine({
          duty,
          deleteAbsences,
          ignoreAbsenceOverlap: true
        });
      }
    }
  );
};
